export default {
    titles: {
        home: 'Home',
        service: 'Service',
        datacenter: 'Datacenter',
        about: 'About',
        // contactUs: 'ContactUs',
        // lange: 'Chinese'
    }
}